module.exports = __webpack_public_path__ + "img/Fake_Video-9.89baf1c3.jpg";